var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import Arrows from "react-icons/lib/fa/arrows";
import { FormattedMessage } from "@irati/utils/lang";
import { MoveWidgetLabel } from "./styled/styled";
var MoveWidget = /** @class */ (function (_super) {
    __extends(MoveWidget, _super);
    function MoveWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MoveWidget.prototype.render = function () {
        var smSquare = this.props.smSquare;
        return (React.createElement(MoveWidgetLabel, { smSquare: smSquare },
            React.createElement(Arrows, null),
            !smSquare && React.createElement(FormattedMessage, { id: "home.feed.moveWidget.label" })));
    };
    return MoveWidget;
}(PureComponent));
export default MoveWidget;
